import { type EmailLoopResponse, type VerificationService } from "../../lib/types/types";

import { EmailLoopCollectOrganizationEmail } from "./EmailLoopCollectOrganizationEmail";
import EmailLoopPendingComponent from "./EmailLoopPending";

export interface StepEmailLoopComponentProps {
  verificationService: VerificationService;
}

export const StepEmailLoopComponent = ({ verificationService }: StepEmailLoopComponentProps) => {
  const isCollectOrgEmailState =
    (verificationService.verificationResponse as EmailLoopResponse).currentState ===
    "collectOrganizationEmail";
  return (
    <div id="sid-step-email-loop" className="sid-step-email-loop-container sid-l-container">
      {isCollectOrgEmailState ? (
        <EmailLoopCollectOrganizationEmail verificationService={verificationService} />
      ) : (
        <EmailLoopPendingComponent verificationService={verificationService} />
      )}
    </div>
  );
};
